import React from 'react';
import * as Card from '../v2BaseComponents/Card';
import Stack from '../v2BaseComponents/Stack';
import { Checkbox } from '../v2BaseComponents/Inputs';
import { View } from 'react-native';

export type SelectableProps = {
    isSelectable: true;
    isSelected: boolean;
    onSelect: () => void;
    isDisabled?: boolean;
};

export type NotSelectableProps = {
    isSelectable: false;
};

export type SelectableMinimalCardOwnProps = {
    children: React.ReactNode;
    onNavigateToDetails?: () => void;
} & (SelectableProps | NotSelectableProps) &
    Partial<Card.CardProps>;

export type SelectableMinimalCardProps = SelectableMinimalCardOwnProps;

const SelectableMinimalCard: React.FC<SelectableMinimalCardProps> = (props) => {
    let left: React.ReactNode | null = null;

    const getCardProps = (): Partial<Card.CardProps> => {
        if (props.isSelectable) {
            const { isSelectable, isSelected, onSelect, isDisabled, children, onNavigateToDetails, ...rest } = props;
            return rest;
        } else {
            const { isSelectable, isDisabled, children, onNavigateToDetails, ...rest } = props;
            return rest;
        }
    };

    if (props.isSelectable) {
        left = (
            <View style={{ height: '100%' }}>
                <Stack vertical flex={1} justify="center" align="center" style={{ marginRight: 10 }}>
                    <Checkbox
                        value={props.isSelected}
                        onChange={() => {
                            props.onSelect();
                        }}
                        isDisabled={props.isDisabled}
                    />
                </Stack>
            </View>
        );
    }

    return (
        <Card.Card
            onPress={props.isSelectable ? () => props.onSelect() : props.onNavigateToDetails}
            {...(props.isSelectable ? { disabled: props.isDisabled } : {})}
            {...getCardProps()}
        >
            {props.isSelectable ? (
                <Card.CardLeftContent leftContent={left}>{props.children}</Card.CardLeftContent>
            ) : (
                props.children
            )}
        </Card.Card>
    );
};

export default React.memo(SelectableMinimalCard);
